import React from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';

const UpdateMenu = ({
    selectedSection,
    selectedOption,
    selectedHomeSection,
    menuSections,
    handleOptionClick,
    handleChangeClick,
    setSelectedHomeSection
}) => {
    if (selectedSection && selectedOption) {
        const section = menuSections.find(s => s.id === selectedSection);
        const option = section.options.find(o => o.id === selectedOption);

        return (
            <div className="selected-menu-view">
                <div className="selected-menu-content">
                    <img
                        src={CreateCloudfrontUrl(section.icon_light)}
                        alt={section.title}
                        className="selected-section-icon"
                    />
                    <div
                        className={`selected-menu-text ${selectedHomeSection ? 'clickable' : ''}`}
                        onClick={() => selectedHomeSection && setSelectedHomeSection(null)}
                    >
                        <span className="selected-section-title">{section.title}</span>
                        <span className="selected-option-arrow">→</span>
                        <span className="selected-option-label">{option.label}</span>
                        {selectedHomeSection && (
                            <>
                                <span className="selected-option-arrow">→</span>
                                <span className="clickable selected-home-section">{selectedHomeSection.title}</span>
                            </>
                        )}
                    </div>
                </div>
                <button
                    className="change-button box-shadow-standard"
                    onClick={handleChangeClick}
                >
                    Switch
                </button>
            </div>
        );
    }

    return (
        <div className="menu-grid">
            {menuSections.map(section => (
                <div key={section.id} className="update-data-menu-section">
                    <div className="update-data-menu-section-header">
                        <div className="update-data-menu-section-header-icon-container">
                            <img
                                src={CreateCloudfrontUrl(section.icon_dark)}
                                alt={section.title}
                                className="update-data-menu-section-header-icon"
                            />
                        </div>
                        <h4>{section.title}</h4>
                    </div>
                    <p className="update-data-menu-section-about-text text-align-center">{section.about}</p>
                    <div className="section-options">
                        {section.options.map(option => (
                            <button
                                key={option.id}
                                className="option-button box-shadow-standard"
                                onClick={() => handleOptionClick(section.id, option.id)}
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UpdateMenu;
